import api from '../../services/api';

// =====================================================
// Action Types
// =====================================================

// Expenses
export const GET_EXPENSES_REQUEST = 'GET_EXPENSES_REQUEST';
export const GET_EXPENSES_SUCCESS = 'GET_EXPENSES_SUCCESS';
export const GET_EXPENSES_FAILURE = 'GET_EXPENSES_FAILURE';

export const GET_EXPENSE_REQUEST = 'GET_EXPENSE_REQUEST';
export const GET_EXPENSE_SUCCESS = 'GET_EXPENSE_SUCCESS';
export const GET_EXPENSE_FAILURE = 'GET_EXPENSE_FAILURE';

export const CREATE_EXPENSE_REQUEST = 'CREATE_EXPENSE_REQUEST';
export const CREATE_EXPENSE_SUCCESS = 'CREATE_EXPENSE_SUCCESS';
export const CREATE_EXPENSE_FAILURE = 'CREATE_EXPENSE_FAILURE';

export const UPDATE_EXPENSE_REQUEST = 'UPDATE_EXPENSE_REQUEST';
export const UPDATE_EXPENSE_SUCCESS = 'UPDATE_EXPENSE_SUCCESS';
export const UPDATE_EXPENSE_FAILURE = 'UPDATE_EXPENSE_FAILURE';

export const DELETE_EXPENSE_REQUEST = 'DELETE_EXPENSE_REQUEST';
export const DELETE_EXPENSE_SUCCESS = 'DELETE_EXPENSE_SUCCESS';
export const DELETE_EXPENSE_FAILURE = 'DELETE_EXPENSE_FAILURE';

export const SUBMIT_EXPENSE_REQUEST = 'SUBMIT_EXPENSE_REQUEST';
export const SUBMIT_EXPENSE_SUCCESS = 'SUBMIT_EXPENSE_SUCCESS';
export const SUBMIT_EXPENSE_FAILURE = 'SUBMIT_EXPENSE_FAILURE';

export const APPROVE_EXPENSE_REQUEST = 'APPROVE_EXPENSE_REQUEST';
export const APPROVE_EXPENSE_SUCCESS = 'APPROVE_EXPENSE_SUCCESS';
export const APPROVE_EXPENSE_FAILURE = 'APPROVE_EXPENSE_FAILURE';

export const REJECT_EXPENSE_REQUEST = 'REJECT_EXPENSE_REQUEST';
export const REJECT_EXPENSE_SUCCESS = 'REJECT_EXPENSE_SUCCESS';
export const REJECT_EXPENSE_FAILURE = 'REJECT_EXPENSE_FAILURE';

export const GET_EXPENSE_STATS_REQUEST = 'GET_EXPENSE_STATS_REQUEST';
export const GET_EXPENSE_STATS_SUCCESS = 'GET_EXPENSE_STATS_SUCCESS';
export const GET_EXPENSE_STATS_FAILURE = 'GET_EXPENSE_STATS_FAILURE';

// Expense Categories
export const GET_EXPENSE_CATEGORIES_REQUEST = 'GET_EXPENSE_CATEGORIES_REQUEST';
export const GET_EXPENSE_CATEGORIES_SUCCESS = 'GET_EXPENSE_CATEGORIES_SUCCESS';
export const GET_EXPENSE_CATEGORIES_FAILURE = 'GET_EXPENSE_CATEGORIES_FAILURE';

export const GET_EXPENSE_CATEGORY_REQUEST = 'GET_EXPENSE_CATEGORY_REQUEST';
export const GET_EXPENSE_CATEGORY_SUCCESS = 'GET_EXPENSE_CATEGORY_SUCCESS';
export const GET_EXPENSE_CATEGORY_FAILURE = 'GET_EXPENSE_CATEGORY_FAILURE';

export const CREATE_EXPENSE_CATEGORY_REQUEST = 'CREATE_EXPENSE_CATEGORY_REQUEST';
export const CREATE_EXPENSE_CATEGORY_SUCCESS = 'CREATE_EXPENSE_CATEGORY_SUCCESS';
export const CREATE_EXPENSE_CATEGORY_FAILURE = 'CREATE_EXPENSE_CATEGORY_FAILURE';

export const UPDATE_EXPENSE_CATEGORY_REQUEST = 'UPDATE_EXPENSE_CATEGORY_REQUEST';
export const UPDATE_EXPENSE_CATEGORY_SUCCESS = 'UPDATE_EXPENSE_CATEGORY_SUCCESS';
export const UPDATE_EXPENSE_CATEGORY_FAILURE = 'UPDATE_EXPENSE_CATEGORY_FAILURE';

export const DELETE_EXPENSE_CATEGORY_REQUEST = 'DELETE_EXPENSE_CATEGORY_REQUEST';
export const DELETE_EXPENSE_CATEGORY_SUCCESS = 'DELETE_EXPENSE_CATEGORY_SUCCESS';
export const DELETE_EXPENSE_CATEGORY_FAILURE = 'DELETE_EXPENSE_CATEGORY_FAILURE';

export const GET_CATEGORY_HIERARCHY_REQUEST = 'GET_CATEGORY_HIERARCHY_REQUEST';
export const GET_CATEGORY_HIERARCHY_SUCCESS = 'GET_CATEGORY_HIERARCHY_SUCCESS';
export const GET_CATEGORY_HIERARCHY_FAILURE = 'GET_CATEGORY_HIERARCHY_FAILURE';

// Expense Vendors
export const GET_EXPENSE_VENDORS_REQUEST = 'GET_EXPENSE_VENDORS_REQUEST';
export const GET_EXPENSE_VENDORS_SUCCESS = 'GET_EXPENSE_VENDORS_SUCCESS';
export const GET_EXPENSE_VENDORS_FAILURE = 'GET_EXPENSE_VENDORS_FAILURE';

export const GET_EXPENSE_VENDOR_REQUEST = 'GET_EXPENSE_VENDOR_REQUEST';
export const GET_EXPENSE_VENDOR_SUCCESS = 'GET_EXPENSE_VENDOR_SUCCESS';
export const GET_EXPENSE_VENDOR_FAILURE = 'GET_EXPENSE_VENDOR_FAILURE';

export const CREATE_EXPENSE_VENDOR_REQUEST = 'CREATE_EXPENSE_VENDOR_REQUEST';
export const CREATE_EXPENSE_VENDOR_SUCCESS = 'CREATE_EXPENSE_VENDOR_SUCCESS';
export const CREATE_EXPENSE_VENDOR_FAILURE = 'CREATE_EXPENSE_VENDOR_FAILURE';

export const UPDATE_EXPENSE_VENDOR_REQUEST = 'UPDATE_EXPENSE_VENDOR_REQUEST';
export const UPDATE_EXPENSE_VENDOR_SUCCESS = 'UPDATE_EXPENSE_VENDOR_SUCCESS';
export const UPDATE_EXPENSE_VENDOR_FAILURE = 'UPDATE_EXPENSE_VENDOR_FAILURE';

export const DELETE_EXPENSE_VENDOR_REQUEST = 'DELETE_EXPENSE_VENDOR_REQUEST';
export const DELETE_EXPENSE_VENDOR_SUCCESS = 'DELETE_EXPENSE_VENDOR_SUCCESS';
export const DELETE_EXPENSE_VENDOR_FAILURE = 'DELETE_EXPENSE_VENDOR_FAILURE';

// Expense Types
export const GET_EXPENSE_TYPES_REQUEST = 'GET_EXPENSE_TYPES_REQUEST';
export const GET_EXPENSE_TYPES_SUCCESS = 'GET_EXPENSE_TYPES_SUCCESS';
export const GET_EXPENSE_TYPES_FAILURE = 'GET_EXPENSE_TYPES_FAILURE';

export const GET_EXPENSE_TYPE_REQUEST = 'GET_EXPENSE_TYPE_REQUEST';
export const GET_EXPENSE_TYPE_SUCCESS = 'GET_EXPENSE_TYPE_SUCCESS';
export const GET_EXPENSE_TYPE_FAILURE = 'GET_EXPENSE_TYPE_FAILURE';

export const CREATE_EXPENSE_TYPE_REQUEST = 'CREATE_EXPENSE_TYPE_REQUEST';
export const CREATE_EXPENSE_TYPE_SUCCESS = 'CREATE_EXPENSE_TYPE_SUCCESS';
export const CREATE_EXPENSE_TYPE_FAILURE = 'CREATE_EXPENSE_TYPE_FAILURE';

export const UPDATE_EXPENSE_TYPE_REQUEST = 'UPDATE_EXPENSE_TYPE_REQUEST';
export const UPDATE_EXPENSE_TYPE_SUCCESS = 'UPDATE_EXPENSE_TYPE_SUCCESS';
export const UPDATE_EXPENSE_TYPE_FAILURE = 'UPDATE_EXPENSE_TYPE_FAILURE';

export const DELETE_EXPENSE_TYPE_REQUEST = 'DELETE_EXPENSE_TYPE_REQUEST';
export const DELETE_EXPENSE_TYPE_SUCCESS = 'DELETE_EXPENSE_TYPE_SUCCESS';
export const DELETE_EXPENSE_TYPE_FAILURE = 'DELETE_EXPENSE_TYPE_FAILURE';

// =====================================================
// Expense Actions
// =====================================================

// Get all expenses
export const getExpenses = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_EXPENSES_REQUEST });

    const queryParams = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        queryParams.append(key, filters[key]);
      }
    });

    const response = await api.get(`/expenses?${queryParams.toString()}`);
    
    dispatch({
      type: GET_EXPENSES_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: GET_EXPENSES_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch expenses'
    });
  }
};

// Get single expense
export const getExpense = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_EXPENSE_REQUEST });

    const response = await api.get(`/expenses/${id}`);
    
    dispatch({
      type: GET_EXPENSE_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: GET_EXPENSE_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch expense'
    });
  }
};

// Create expense
export const createExpense = (expenseData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_EXPENSE_REQUEST });

    const response = await api.post('/expenses', expenseData);
    
    dispatch({
      type: CREATE_EXPENSE_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: CREATE_EXPENSE_FAILURE,
      payload: error.response?.data?.message || 'Failed to create expense'
    });
  }
};

// Update expense
export const updateExpense = (id, expenseData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_EXPENSE_REQUEST });

    const response = await api.put(`/expenses/${id}`, expenseData);
    
    dispatch({
      type: UPDATE_EXPENSE_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: UPDATE_EXPENSE_FAILURE,
      payload: error.response?.data?.message || 'Failed to update expense'
    });
  }
};

// Delete expense
export const deleteExpense = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_EXPENSE_REQUEST });

    await api.delete(`/expenses/${id}`);
    
    dispatch({
      type: DELETE_EXPENSE_SUCCESS,
      payload: { id }
    });
  } catch (error) {
    dispatch({
      type: DELETE_EXPENSE_FAILURE,
      payload: error.response?.data?.message || 'Failed to delete expense'
    });
  }
};

// Submit expense for approval
export const submitExpense = (id, notes) => async (dispatch) => {
  try {
    dispatch({ type: SUBMIT_EXPENSE_REQUEST });

    const response = await api.post(`/expenses/${id}/submit`, { notes });
    
    dispatch({
      type: SUBMIT_EXPENSE_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: SUBMIT_EXPENSE_FAILURE,
      payload: error.response?.data?.message || 'Failed to submit expense'
    });
  }
};

// Approve expense
export const approveExpense = (id, approvedAmount, comments) => async (dispatch) => {
  try {
    dispatch({ type: APPROVE_EXPENSE_REQUEST });

    const response = await api.post(`/expenses/${id}/approve`, { 
      approved_amount: approvedAmount, 
      comments 
    });
    
    dispatch({
      type: APPROVE_EXPENSE_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: APPROVE_EXPENSE_FAILURE,
      payload: error.response?.data?.message || 'Failed to approve expense'
    });
  }
};

// Reject expense
export const rejectExpense = (id, comments) => async (dispatch) => {
  try {
    dispatch({ type: REJECT_EXPENSE_REQUEST });

    const response = await api.post(`/expenses/${id}/reject`, { comments });
    
    dispatch({
      type: REJECT_EXPENSE_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: REJECT_EXPENSE_FAILURE,
      payload: error.response?.data?.message || 'Failed to reject expense'
    });
  }
};

// Get expense statistics
export const getExpenseStats = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_EXPENSE_STATS_REQUEST });

    const queryParams = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        queryParams.append(key, filters[key]);
      }
    });

    const response = await api.get(`/expenses/stats?${queryParams.toString()}`);
    
    dispatch({
      type: GET_EXPENSE_STATS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: GET_EXPENSE_STATS_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch expense statistics'
    });
  }
};

// =====================================================
// Expense Category Actions
// =====================================================

// Get all expense categories
export const getExpenseCategories = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_EXPENSE_CATEGORIES_REQUEST });

    const queryParams = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        queryParams.append(key, filters[key]);
      }
    });

    const response = await api.get(`/expenses/categories?${queryParams.toString()}`);
    
    dispatch({
      type: GET_EXPENSE_CATEGORIES_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: GET_EXPENSE_CATEGORIES_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch expense categories'
    });
  }
};

// Get category hierarchy
export const getCategoryHierarchy = () => async (dispatch) => {
  try {
    dispatch({ type: GET_CATEGORY_HIERARCHY_REQUEST });

    const response = await api.get('/expenses/categories/hierarchy');
    
    dispatch({
      type: GET_CATEGORY_HIERARCHY_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: GET_CATEGORY_HIERARCHY_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch category hierarchy'
    });
  }
};

// Create expense category
export const createExpenseCategory = (categoryData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_EXPENSE_CATEGORY_REQUEST });

    const response = await api.post('/expenses/categories', categoryData);
    
    dispatch({
      type: CREATE_EXPENSE_CATEGORY_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: CREATE_EXPENSE_CATEGORY_FAILURE,
      payload: error.response?.data?.message || 'Failed to create expense category'
    });
  }
};

// Update expense category
export const updateExpenseCategory = (id, categoryData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_EXPENSE_CATEGORY_REQUEST });

    const response = await api.put(`/expenses/categories/${id}`, categoryData);
    
    dispatch({
      type: UPDATE_EXPENSE_CATEGORY_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: UPDATE_EXPENSE_CATEGORY_FAILURE,
      payload: error.response?.data?.message || 'Failed to update expense category'
    });
  }
};

// Delete expense category
export const deleteExpenseCategory = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_EXPENSE_CATEGORY_REQUEST });

    await api.delete(`/expenses/categories/${id}`);
    
    dispatch({
      type: DELETE_EXPENSE_CATEGORY_SUCCESS,
      payload: { id }
    });
  } catch (error) {
    dispatch({
      type: DELETE_EXPENSE_CATEGORY_FAILURE,
      payload: error.response?.data?.message || 'Failed to delete expense category'
    });
  }
};

// =====================================================
// Expense Vendor Actions
// =====================================================

// Get all expense vendors
export const getExpenseVendors = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_EXPENSE_VENDORS_REQUEST });

    const queryParams = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        queryParams.append(key, filters[key]);
      }
    });

    const response = await api.get(`/expenses/vendors?${queryParams.toString()}`);
    
    dispatch({
      type: GET_EXPENSE_VENDORS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: GET_EXPENSE_VENDORS_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch expense vendors'
    });
  }
};

// Create expense vendor
export const createExpenseVendor = (vendorData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_EXPENSE_VENDOR_REQUEST });

    const response = await api.post('/expenses/vendors', vendorData);
    
    dispatch({
      type: CREATE_EXPENSE_VENDOR_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: CREATE_EXPENSE_VENDOR_FAILURE,
      payload: error.response?.data?.message || 'Failed to create expense vendor'
    });
  }
};

// Update expense vendor
export const updateExpenseVendor = (id, vendorData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_EXPENSE_VENDOR_REQUEST });

    const response = await api.put(`/expenses/vendors/${id}`, vendorData);
    
    dispatch({
      type: UPDATE_EXPENSE_VENDOR_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: UPDATE_EXPENSE_VENDOR_FAILURE,
      payload: error.response?.data?.message || 'Failed to update expense vendor'
    });
  }
};

// Delete expense vendor
export const deleteExpenseVendor = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_EXPENSE_VENDOR_REQUEST });

    await api.delete(`/expenses/vendors/${id}`);
    
    dispatch({
      type: DELETE_EXPENSE_VENDOR_SUCCESS,
      payload: { id }
    });
  } catch (error) {
    dispatch({
      type: DELETE_EXPENSE_VENDOR_FAILURE,
      payload: error.response?.data?.message || 'Failed to delete expense vendor'
    });
  }
};

// =====================================================
// Expense Type Actions
// =====================================================

// Get all expense types
export const getExpenseTypes = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_EXPENSE_TYPES_REQUEST });

    const queryParams = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        queryParams.append(key, filters[key]);
      }
    });

    const response = await api.get(`/expenses/types?${queryParams.toString()}`);
    
    dispatch({
      type: GET_EXPENSE_TYPES_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: GET_EXPENSE_TYPES_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch expense types'
    });
  }
};

// Create expense type
export const createExpenseType = (typeData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_EXPENSE_TYPE_REQUEST });

    const response = await api.post('/expenses/types', typeData);
    
    dispatch({
      type: CREATE_EXPENSE_TYPE_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: CREATE_EXPENSE_TYPE_FAILURE,
      payload: error.response?.data?.message || 'Failed to create expense type'
    });
  }
};

// Update expense type
export const updateExpenseType = (id, typeData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_EXPENSE_TYPE_REQUEST });

    const response = await api.put(`/expenses/types/${id}`, typeData);
    
    dispatch({
      type: UPDATE_EXPENSE_TYPE_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: UPDATE_EXPENSE_TYPE_FAILURE,
      payload: error.response?.data?.message || 'Failed to update expense type'
    });
  }
};

// Delete expense type
export const deleteExpenseType = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_EXPENSE_TYPE_REQUEST });

    await api.delete(`/expenses/types/${id}`);
    
    dispatch({
      type: DELETE_EXPENSE_TYPE_SUCCESS,
      payload: { id }
    });
  } catch (error) {
    dispatch({
      type: DELETE_EXPENSE_TYPE_FAILURE,
      payload: error.response?.data?.message || 'Failed to delete expense type'
    });
  }
};
